import React, { Component } from 'react';
import Formsy from 'formsy-react';

import withModal from '../../common/WithModal';
import Input from '../global/fields/Input';
import TextArea from '../global/fields/TextArea';
import FormsyCheckbox from '../global/fields/Checkbox';

class SaveCartModal extends Component {
  state = {
    canSubmit: false,
  };

  modal = {
    containerClassName: 'save-cart-modal__container',
  };

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(form) {
    const {
      onSubmit,
    } = this.props;

    onSubmit(form);
  }

  switchSubmit(isValid) {
    this.setState({ canSubmit: isValid });
  }

  renderForm() {
    const {
      canSubmit,
    } = this.state;

    return (
      <Formsy
        className="save-cart-modal__grid form-fancy"
        onValidSubmit={this.handleSubmit}
        onValid={this.switchSubmit.bind(this, true)}
        onInvalid={this.switchSubmit.bind(this, false)}
      >
        <h3 className="save-cart-modal__header">
          Send my saved cart to my email
        </h3>
        <div className="form-fancy-wrapper save-cart-modal__input-wrapper">
          <Input
            label="Email"
            name="email"
            required={true}
            validations="isEmail"
            validationError="Invalid Email"
            autocapitalize="none"
          />
        </div>
        <div className="form-fancy-wrapper save-cart-modal__input-wrapper">
          <TextArea
            label="Note (optional)"
            name="note"
          />
        </div>
        <div className="save-cart-modal__input-wrapper">
          <FormsyCheckbox
            label="Also subscribe to news about new products, exclusive sales, and more."
            name="subscribe"
          />
        </div>
        <div className="auth-form-wrapper">
          <button type="submit" disabled={!canSubmit} className="save-cart-modal__submit-button btn btn-terracotta">
            Send Cart
          </button>
        </div>
        <p className="save-cart-modal__footer body-medium">
          You can unsubscribe at any time.
        </p>
      </Formsy>
    );
  }

  renderConfirmation() {
    const {
      onClose,
    } = this.props;
    return (
      <div className="save-cart-modal__grid">
        <h3 className="save-cart-modal__header">
          Your cart has been sent to the email address provided
        </h3>
        <a
          className="save-cart-modal__continue-shopping"
          role="button"
          onClick={onClose}
        >
          Continue shopping
        </a>
      </div>
    );
  }

  render() {
    const {
      saved,
    } = this.props;

    return !saved
      ? this.renderForm()
      : this.renderConfirmation();
  }
}

export default withModal(SaveCartModal);
